import { Chip } from "@mui/material";
import { useRecordContext } from "react-admin";
import type { ProviderType } from "../../../types/api";

export const ProviderTypeChip = () => {
  const record = useRecordContext();
  if (!record) return null;

  const type = record.type as ProviderType;

  const getTypeLabel = (type: ProviderType) => {
    return type
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <Chip
      label={getTypeLabel(type)}
      size="small"
      variant="outlined"
      color="primary"
    />
  );
};
